import { render, staticRenderFns } from "./IconSvgACPANewsFeed.vue?vue&type=template&id=3d9ac987&scoped=true&"
import script from "./IconSvgACPANewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgACPANewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ac987",
  null
  
)

export default component.exports